import dayjs from 'dayjs';
import { all, call, fork, put, takeLeading } from 'redux-saga/effects';
import { LAST_ACTIVITY_KEY } from 'src/common/constants';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from 'src/common/helpers/HTTPRequest';
import { clearAllToasts, toastError } from 'src/common/helpers/Notifications';
import {
  setUserInfo,
  setUserRefreshToken,
  setUserToken,
} from 'src/common/helpers/StorageUtils';
import TextConstants from 'src/common/helpers/TextConstants';
import {
  loginActions,
  performLoginCleanState,
  performLoginError,
  performLoginSuccess,
  performLogoutCleanState,
  performLogoutError,
  performLogoutSuccess,
  performTokenExpiredSuccess,
} from './actions';

function* loginUser({ payload }) {
  try {
    const requestBody = { ...payload };
    const url = `${ApiConstants.BASE_URL}${ApiConstants.LOGIN_URL}`;
    const apiRes = yield call(requests.postRequest, url, requestBody, false);
    if (apiRes) {
      // store user token
      setUserToken(apiRes.idToken);
      setUserRefreshToken(apiRes.refreshToken);
      setUserInfo(apiRes.user);
      clearAllToasts();
      yield put(performLoginSuccess(apiRes));

      localStorage.setItem(LAST_ACTIVITY_KEY, dayjs().valueOf().toString());
    } else {
      yield put(performLoginError({ message: 'Oops! something went wrong!' }));
    }
  } catch (error) {
    console.log(error);
    yield put(performLoginError({ message: error?.message || '' }));
  } finally {
    yield put(performLoginCleanState());
  }
}

function* logoutUser({ payload }) {
  try {
    const { isTokenExpired } = payload;
    // clear all from storage
    localStorage.clear();
    if (isTokenExpired) {
      toastError(TextConstants.Common.SessionExpired);
      yield put(
        performTokenExpiredSuccess(TextConstants.Common.SessionExpired)
      );
    } else {
      yield put(
        performLogoutSuccess(TextConstants.Common.loggedOutSuccessfully)
      );
    }
  } catch (error) {
    yield put(performLogoutError());
  } finally {
    yield put(performLogoutCleanState());
  }
}

export function* watchLoginUser() {
  yield takeLeading(loginActions.LOGIN, loginUser);
  yield takeLeading(loginActions.LOGOUT, logoutUser);
}

export default function* rootSaga() {
  yield all([fork(watchLoginUser)]);
}
